import React, { Component, Fragment } from 'react';
import Message from './ValidationMessage';
import InlineField from './InlineField';

export class DecimalField extends Component {
  render() {
    let {
      intl,
      readOnly,
      translation,
      input,
      required,
      label,
      disabled = false,
      placeholder,
      id,
      min,
      max,
      displayType,
      meta: { touched, error, warning },
    } = this.props;
    if (intl && translation) {
      const labelObj = translation.label;
      const placeholderObj = translation.placeholder;
      if (labelObj && labelObj.message) {
        label = intl.formatMessage(labelObj.message, labelObj.params);
      }
      if (placeholderObj && placeholderObj.message) {
        placeholder = intl.formatMessage(
          placeholderObj.message,
          placeholderObj.params,
        );
      }
    }

    let showError = touched && error ? 'error' : '';

    if (displayType === 'inline') {
      return (
        <InlineField
          fieldType="renderDecimal"
          translation={translation}
          content={input.value}
          label={label}
          id={id}
        />
      );
    }

    return (
      <div
        className={`${required && 'required'} ${disabled &&
          'disabled'} field ${showError}`}
      >
        {label && <label>{label}</label>}
        <Fragment>
          <input
            {...input}
            type="number"
            placeholder={placeholder}
            id={id}
            min={min}
            max={max}
            readOnly={readOnly}
            step="1"
          />
          <Message show={touched} message={error} />
          <Message show={touched} message={warning} />
        </Fragment>
      </div>
    );
  }
}

export const DECIMAL = (places, min, max, maxDecimalPlace) => {
  return (value) => {
    if (places) {
      return Number(value).toFixed(places);
    }

    const numberValue = Number(value);
    const numberMin = Number(min);
    const numberMax = Number(max);

    const minValue = Math.min(numberValue, numberMin);

    const invalidMin = min === null || min === undefined;
    const invalidMax = max === null || max === undefined;

    if (!invalidMin && minValue === numberValue) {
      value = numberMin;
    } else if (invalidMin) {
      value = numberValue;
    } else {
      const maxValue = Math.max(numberValue, numberMax);
      if (!invalidMax && maxValue === numberValue) {
        value = numberMax;
      }
    }

    if (maxDecimalPlace != null || min !== undefined) {
      if (countDecimalPlaces(value, maxDecimalPlace) > maxDecimalPlace) {
        const fixedDecimalPlace = Number(value).toFixed(maxDecimalPlace);

        return Number(fixedDecimalPlace);
      }
    }

    return value;
  };
};

export const asDecimal = (amount) => {
  return DECIMAL()(amount);
};

function countDecimalPlaces(num, maxDecimalPlace) {
  var match = ('' + num).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
  if (!match) {
    return maxDecimalPlace;
  }
  return Math.max(
    0,
    // Number of digits right of decimal point.
    (match[1] ? match[1].length : 0) -
      // Adjust for scientific notation.
      (match[2] ? +match[2] : 0),
  );
}

/* Example:
  <Field
    name={`${data}.purchase_cost`}
    label="Cost price"
    parse={Input.DECIMAL(3)}
    component={renderDecimal} />
*/
